import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import type { InitialStateType } from './types';

export const maintenanceInitialState: InitialStateType = {
  isActive: false,
};

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState: maintenanceInitialState,
  reducers,
});

export const { maintenanceModeDetected, maintenanceModeCleared } = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
